import type { CSSProperties, ReactNode } from "react";

type RuntimeMaxWidthAttributes = { style: CSSProperties };

type RuntimeMaxWidthProps = {
  maxWidth: CSSProperties["maxWidth"];
  children: (attributes: RuntimeMaxWidthAttributes) => ReactNode;
};

/** Applies an exact chart maximum that is rendering geometry rather than a reusable design-system measure. */
export function RuntimeMaxWidth({ maxWidth, children }: RuntimeMaxWidthProps): ReactNode {
  return children({ style: { maxWidth } });
}
